import React from 'react';
import { Input } from '@morressier/alembic';
import { Flex } from '@chakra-ui/react';
import { FieldLabel } from 'src/components/Field';
import { FieldError as IFieldError, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { FormFieldIntegerInput } from '@publishing-engine/domain/types/article';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';

interface IFormFieldIntegerProps {
  config: FormFieldIntegerInput;
  isEditingAllowed?: boolean;
}

const FormFieldInteger: React.FC<IFormFieldIntegerProps> = ({
  config,
  isEditingAllowed = true
}) => {
  const {
    params: { validations, labels },
    caseDataFields: { main: fieldPath }
  } = config;

  const {
    formState: { errors },
    register
  } = useFormContext();

  const error = _.get(errors, fieldPath) as IFieldError;

  return (
    <Flex flexDirection="column" gap={2} alignItems="flex-start">
      <FieldLabel
        label={labels.main}
        subText={labels.subtitle}
        isRequired={validations.required}
        helpText={labels.helpText}
      />
      <Flex flexDirection="column" flex={1} width={'100%'} gap={2}>
        <Input
          type="number"
          min={0}
          step={1}
          defaultValue=""
          {...register(fieldPath, {
            required: validations.required,
            min: {
              value: 0,
              message: 'Value must be 0 or greater'
            },
            validate: value =>
              value === '' || value === null || value >= 0 || 'Invalid number',
            setValueAs: value => {
              if (value === '' || value === null) return null;
              const num = Number(value);
              return Number.isNaN(num) || num < 0 ? null : num;
            }
          })}
          isInvalid={Boolean(error)}
          placeholder={labels.placeholder}
          isReadOnly={!isEditingAllowed}
          aria-label={labels.main}
        />
        <FormFieldErrorMessage config={config} />
      </Flex>
    </Flex>
  );
};

export default FormFieldInteger;
